export default __webpack_public_path__ + "static/media/f1.d51793bc.png";